var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgSearch(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.616 21.806l.015.016a1.277 1.277 0 01-.037 1.83 1.292 1.292 0 01-.883.348c-.342 0-.675-.135-.905-.369l-2.97-2.881a7.156 7.156 0 01-3.766 1.064c-3.894 0-7.07-3.091-7.07-6.907S11.176 8 15.07 8c3.893 0 7.07 3.091 7.07 6.907 0 1.507-.5 2.94-1.395 4.114l2.87 2.785zm-8.546-2.554c2.482 0 4.492-1.956 4.492-4.345s-2.01-4.344-4.492-4.344-4.492 1.955-4.492 4.344c0 2.389 2.01 4.345 4.492 4.345z"
  }));
}

export default SvgSearch;